import { useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useExport = () => {
  const httpClient = useHttpClient(true, true);
  const [loading, setLoading] = useState(false);
  const triggerExport = async (data) => {
    const params = {
      project: data.project,
      project_start_date: data.project_start_date,
      project_end_date: data.project_end_date,
      activities: data.activities,
      subactivities: data.subactivities,
      productions: data.productions,
    };
    setLoading(true);
  
    const querystring = require('querystring');

    const queryString = querystring.stringify(params);
    const response = await httpClient.current?.get( `/api/project/export?${queryString}`);
    const blob = response.data;
    const name = response.headers['content-disposition'].split('filename=')[1];
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
  };

  return { triggerExport, loading };
};
